export function formatListAscOrder(subarray1: [string, number], subarray2: [string, number]): number {
  const value1 = parseInt(subarray1[0]);
  const value2 = parseInt(subarray2[0]);
  return value1 - value2;
}
